var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoll = function SvgPoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm.4 1.4a1 1 0 0 0-1 1v4.2a1 1 0 0 0 1 1h4.2a1 1 0 0 0 1-1V5.4a1 1 0 0 0-1-1H4.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54 8.451 4.289 7.2l-.426.423L5.54 9.3l3.6-3.6-.423-.423z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2zm.4 1.4a1 1 0 0 0-1 1v4.2a1 1 0 0 0 1 1h4.2a1 1 0 0 0 1-1v-4.2a1 1 0 0 0-1-1H4.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.81 15.655-.465-.465L6.5 17.035 4.655 15.19l-.465.465L6.035 17.5 4.19 19.345l.465.465L6.5 17.965l1.845 1.845.465-.465L6.965 17.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 5.3,
    width: 8,
    height: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8.7,
    width: 5,
    height: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15.3,
    width: 8,
    height: 2,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 18.7,
    width: 5,
    height: 2,
    rx: 1
  })));
};
export default SvgPoll;